const INLOOK = 'inlook';
const INLOOK_OLD = 'inlook-old';
const SUPPLIER = 'supplier';

export { INLOOK, INLOOK_OLD, SUPPLIER };
